

export function mine_values(values, left=1.0) {
  const l = values.length;
  let [a,b,c] = [Array(l).fill(0), Array(l).fill(0), Array(l).fill(0)];

  let ilowest = -1;
  let na, nb
  for (let [i,z] of values.entries()) {
    na = Math.min(z, left)
    left = left - na
    nb = z - na
    a[i] = na
    b[i] = nb
    c[i] = nb === 0 ? 0 : nb/z
    ilowest = b[i] === 0 && ilowest === i-1 ? i : ilowest
  }
  return [a,b,c,ilowest];

}


export function gcolor(n) {
  const bases = [
      [[240,.35,.35],[240,.65,.60],[240,.35,.75]],
      [[80,.35,.35],[80,.55,.45],[80,.35,.75]],
      [[40,.35,.35],[45,.75,.45],[40,.35,.75]],
      [[0,.35,.35],[0,.65,.55],[0,.35,.75]],
      [[300,.35,.35],[300,.65,.50],[300,.35,.75]],
  ]
  let a,b;

  const under = [0,.0,.35]
  const excess = [0,.0,.85]

  n = Math.round(n*1000)/1000
  n = n * 10.0
  if (n < 0.0){
    return under
  } else if (n >= 10.0) {
    return excess
  }

  const cat = Math.floor(n/2)
  const sub = (n)%1

  if (n/2%1 < 0.5) {
    a = bases[cat][0]
    b = bases[cat][1]
  } else {
    a = bases[cat][1]
    b = bases[cat][2]
  }

  let ca = 1-sub
  let cb = sub

  let final = [
    ca*a[0] + cb*b[0],
    ca*a[1] + cb*b[1],
    ca*a[2] + cb*b[2],
  ]

  return final
}


export function values_sumf(a,b, fa=1, fb=1) {

  if(!Array.isArray(b)) {
    return values_sumf(a, a, b, 0)
  }

  return a.map((_, i) => a[i]*fa+b[i]*fb)
}


//export gcolor;



// WEBPACK FOOTER //
// ./src/wtfutil.js